import { __assign, __awaiter, __generator } from "tslib";
import axios from "axios";
import { addDays, getDaysInMonth, isAfter, isBefore, set, subDays, } from "date-fns";
// Função para calcular o MDC (Máximo Divisor Comum) usando o Algoritmo de Euclides
export var mdc = function (a, b) {
    var _a;
    while (b !== 0) {
        _a = [b, a % b], a = _a[0], b = _a[1];
    }
    return a;
};
// Função para calcular o MMC (Mínimo Múltiplo Comum) de dois números
export var mmc = function (a, b) {
    return Math.abs(a * b) / mdc(a, b);
};
// Função para calcular o MMC de um array de números
export var mmcArray = function (numbers) {
    return numbers.reduce(function (acc, num) { return mmc(acc, num); }, 1);
};
// Função para formatar preço
export var formatPrice = function (price, options) {
    if (typeof price === "string") {
        price = price.replace(/\./g, "").replace(",", "");
    }
    var parsedPrice = typeof price === "string" ? parseFloat(price) / 100 : price;
    var amount = new Intl.NumberFormat("pt-BR", __assign({ style: "currency", currency: "BRL" }, options)).format(parsedPrice);
    return (options === null || options === void 0 ? void 0 : options.hasPrefix) === false ? "".concat(amount).substring(3) : "".concat(amount);
};
// Função para mascarar uma string
export var maskString = function (string, percent, char) {
    if (percent === void 0) { percent = 50; }
    if (char === void 0) { char = "*"; }
    var length = string.length;
    var charAmount = length * (percent / 100);
    var firstAmount = Math.floor((length - charAmount) / 2);
    return (string.substring(0, firstAmount) +
        char.repeat(charAmount) +
        string.substring(firstAmount + charAmount));
};
// Função para limpar telefone
export var clearPhone = function (phone) {
    return phone.replace(/\D/g, "");
};
// Função para validar um CPF
export var validateCPF = function (cpf) {
    if (cpf.length !== 11) {
        return false;
    }
    if (cpf.match(/(\d)\1{10}/)) {
        return false;
    }
    var numbers = cpf.substring(0, 9);
    var digits = cpf.substring(9);
    var sum = numbers
        .split("")
        .map(function (number, index) { return parseInt(number) * (10 - index); })
        .reduce(function (acc, curr) { return acc + curr; });
    var firstDigit = (sum * 10) % 11;
    if (firstDigit.toString() !== digits.charAt(0)) {
        return false;
    }
    var sum2 = numbers
        .split("")
        .map(function (number, index) { return parseInt(number) * (11 - index); })
        .reduce(function (acc, curr) { return acc + curr; });
    var secondDigit = (sum2 * 10) % 11;
    return secondDigit.toString() === digits.charAt(1);
};
// Função para buscar endereço pelo cep
export var getAddressByCep = function (cep) { return __awaiter(void 0, void 0, void 0, function () {
    var formattedCep, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formattedCep = cep.replace(/(\.|-)/gi, "");
                return [4 /*yield*/, axios.get("https://viacep.com.br/ws/".concat(formattedCep, "/json/"))];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
// Função para converter HEX para RGB
export var hexToRgb = function (hex) {
    // Remove o '#' se presente
    hex = hex.replace(/^#/, "");
    // Converter HEX para os componentes RGB
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return [r, g, b];
};
// Função para converter RGB para HSB
export var rgbToHsb = function (r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    var v = Math.max(r, g, b), n = v - Math.min(r, g, b);
    var h = n === 0
        ? 0
        : n && v === r
            ? (g - b) / n
            : v === g
                ? 2 + (b - r) / n
                : 4 + (r - g) / n;
    return [60 * (h < 0 ? h + 6 : h), v && (n / v) * 100, v * 100];
};
// Função para converter HEX para HSB
export var hexToHsb = function (hex) {
    // Remove o '#' se presente
    hex = hex.replace(/^#/, "");
    // Converter HEX para RGB
    var r = parseInt(hex.substring(0, 2), 16) / 255;
    var g = parseInt(hex.substring(2, 4), 16) / 255;
    var b = parseInt(hex.substring(4, 6), 16) / 255;
    // Calcular o máximo e mínimo entre R, G, B
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var delta = max - min;
    // Calcular brilho (B)
    var bValue = max * 100;
    // Calcular saturação (S)
    var sValue = max === 0 ? 0 : (delta / max) * 100;
    // Calcular matiz (H)
    var hValue = 0;
    if (delta !== 0) {
        if (max === r)
            hValue = (g - b) / delta + (g < b ? 6 : 0);
        else if (max === g)
            hValue = (b - r) / delta + 2;
        else
            hValue = (r - g) / delta + 4;
        hValue = Math.round(hValue * 60);
    }
    return [hValue, Math.round(sValue), Math.round(bValue)];
};
export var rgbToHex = function (number) {
    return number.toString(16).padStart(2, "0");
};
// Função para converter HSB para HEX
var hsbToHex = function (h, s, b) {
    s /= 100;
    b /= 100;
    var c = b * s;
    var x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    var m = b - c;
    var r = 0, g = 0, bl = 0;
    if (0 <= h && h < 60) {
        r = c;
        g = x;
        bl = 0;
    }
    else if (60 <= h && h < 120) {
        r = x;
        g = c;
        bl = 0;
    }
    else if (120 <= h && h < 180) {
        r = 0;
        g = c;
        bl = x;
    }
    else if (180 <= h && h < 240) {
        r = 0;
        g = x;
        bl = c;
    }
    else if (240 <= h && h < 300) {
        r = x;
        g = 0;
        bl = c;
    }
    else if (300 <= h && h < 360) {
        r = c;
        g = 0;
        bl = x;
    }
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    bl = Math.round((bl + m) * 255);
    return "#".concat(rgbToHex(r)).concat(rgbToHex(g)).concat(rgbToHex(bl));
};
// Função para gerar variações de cor
export var generateColorVariants = function (hex) {
    // Converter de HEX para HSB
    var _a = hexToHsb(hex), h = _a[0], s = _a[1], b = _a[2];
    // Gerar cor mais clara: -20 de S, +4 de L
    var lightS = Math.max(s - 20, 0); // Garantir que S não seja negativo
    var lightB = Math.min(b + 4, 100); // Garantir que L não passe de 100
    var lightColor = hsbToHex(h, lightS, lightB);
    // Gerar cor ainda mais clara: -40 de S, +8 de L
    var lighterS = Math.max(s - 40, 0); // Garantir que S não seja negativo
    var lighterB = Math.min(b + 8, 100); // Garantir que L não passe de 100
    var lighterColor = hsbToHex(h, lighterS, lighterB);
    // Gerar cor ainda mais clara: -60 de S, +12 de L
    var lightestS = Math.max(s - 60, 0); // Garantir que S não seja negativo
    var lightestB = Math.min(b + 12, 100); // Garantir que L não passe de 100
    var lightestColor = hsbToHex(h, lightestS, lightestB);
    // Gerar cor mais escura: +4 de S, -20 de L
    var darkS = Math.min(s + 4, 100); // Garantir que S não passe de 100
    var darkB = Math.max(b - 20, 0); // Garantir que L não seja negativo
    var darkColor = hsbToHex(h, darkS, darkB);
    // Gerar cor ainda mais escura: +8 de S, -40 de L
    var darkerS = Math.min(s + 8, 100); // Garantir que S não passe de 100
    var darkerB = Math.max(b - 40, 0); // Garantir que L não seja negativo
    var darkerColor = hsbToHex(h, darkerS, darkerB);
    return {
        lightest: lightestColor,
        lighter: lighterColor,
        light: lightColor,
        default: hex,
        dark: darkColor,
        darker: darkerColor,
    };
};
export var getBrighterColor = function (hex, percentage) {
    var _a = hexToRgb(hex), r = _a[0], g = _a[1], b = _a[2];
    var lightenChannel = function (channel) {
        return Math.round(channel + (255 - channel) * (percentage / 100));
    };
    r = lightenChannel(r);
    g = lightenChannel(g);
    b = lightenChannel(b);
    return "#".concat(rgbToHex(r)).concat(rgbToHex(g)).concat(rgbToHex(b));
};
// Função para preencher um array de datas
export var fillDaysArray = function (arr) {
    var firstDay = arr[0];
    for (var i = 1; i <= firstDay.getDay(); i++) {
        var date = subDays(firstDay, i);
        arr.unshift(date);
    }
    var multiplier = Math.ceil(arr.length / 7);
    var left = 7 * multiplier - arr.length;
    var lastDay = arr[arr.length - 1];
    for (var i = 1; i <= left; i++) {
        var date = addDays(lastDay, i);
        arr.push(date);
    }
};
// Função para aceitar apenas horas validas numa string e ajustar conforme necessário
export var clampTimeString = function (timeStr, currentDate, type, compareDate) {
    var _a = timeStr.split(":"), hourStr = _a[0], minuteStr = _a[1];
    var hours = parseInt(hourStr, 10);
    var minutes = parseInt(minuteStr, 10);
    // Ajuste para valores válidos de horas e minutos
    hours = Math.max(0, Math.min(23, hours));
    minutes = Math.max(0, Math.min(59, minutes));
    // Define a data ajustada com partes preservadas de currentDate
    var adjustedDate = set(currentDate, { hours: hours, minutes: minutes });
    // Verifica e aplica restrições
    if (compareDate && type === "start" && isAfter(adjustedDate, compareDate)) {
        return compareDate;
    }
    else if (compareDate &&
        type === "end" &&
        isBefore(adjustedDate, compareDate)) {
        return compareDate;
    }
    return adjustedDate;
};
// Função para aceitar apenas datas validas numa string e ajustar conforme necessário
export var clampDateString = function (dateStr, currentDate, type, compareDate) {
    var _a = dateStr.split("/"), dayStr = _a[0], monthStr = _a[1], yearStr = _a[2];
    var day = parseInt(dayStr, 10);
    var month = parseInt(monthStr, 10) - 1;
    var year = parseInt(yearStr, 10);
    // Ajuste do mês e do dia
    month = Math.max(0, Math.min(11, month));
    var maxDay = getDaysInMonth(new Date(year, month));
    day = Math.max(1, Math.min(maxDay, day));
    // Define a data ajustada com partes preservadas de currentDate
    var adjustedDate = set(currentDate, { year: year, month: month, date: day });
    if (compareDate && type === "start" && isAfter(adjustedDate, compareDate)) {
        return compareDate;
    }
    else if (compareDate &&
        type === "end" &&
        isBefore(adjustedDate, compareDate)) {
        return compareDate;
    }
    return adjustedDate;
};
export function currencyFormatter(value, hasPrefix, minimumFractionDigits) {
    if (minimumFractionDigits === void 0) { minimumFractionDigits = 2; }
    if (!Number(value))
        return "";
    var amount = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: minimumFractionDigits,
    }).format(value / Math.pow(10, minimumFractionDigits));
    return hasPrefix ? "".concat(amount) : "".concat(amount).substring(3);
}
//# sourceMappingURL=functions.js.map